/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetUploadIcon24Solid = forwardRef('NetUploadIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.247 8.621A1.5 1.5 0 1 1 4.253 6.38L9.51 1.708a3.75 3.75 0 0 1 4.982 0l5.256 4.67a1.5 1.5 0 0 1-1.994 2.243L13.5 4.841V16.5a1.5 1.5 0 0 1-3 0V4.84L6.247 8.621Z" }),
        React.createElement("path", { d: "M2 21.5A1.5 1.5 0 0 1 3.5 20h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 21.5Z" })));
});
